
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h24v24H0z","data-name":"사각형 1220","fill":"none"}}),_c('path',{attrs:{"d":"M3 22V2h18v5h-2V4H5v16h14v-3h2v5zm13.6-7.2l1.8-1.8H11v-2h7.4l-1.8-1.8L18 7.8l4.3 4.2-4.3 4.2z","data-name":"합치기 39"}})])
          )
        }
      }
    